// extracted by mini-css-extract-plugin
export var landingPage = "LandingStyles-module--landing-page--3RNXb";
export var contentLevel1Container = "LandingStyles-module--content-level1-container--1M2Th";
export var stmntContainer = "LandingStyles-module--stmnt-container--2sq4d";
export var screenViewContainer = "LandingStyles-module--screen-view-container--3aMt1";
export var screenViewImg = "LandingStyles-module--screen-view-img--13X-q";
export var learnMoreBtn = "LandingStyles-module--learn-more-btn--1KNIV";
export var contentLevel2Container = "LandingStyles-module--content-level2-container--15nM_";
export var summaryContainer = "LandingStyles-module--summary-container--354pT";
export var iconImg = "LandingStyles-module--icon-img--2afbM";